import React, { Component } from 'react'

export default class filterPass extends Component {

    passwordValidataion = () => {
       
        const NumberRegex = new RegExp("(?=.*[0-9])");
        const SpecialRegex = new RegExp("(?=.[!@#\$%\^&])");
        const LengthRegex = new RegExp("(?=.{4,})");
        const LowerRegex = new RegExp("^(?=.*[a-z])");
        const UpperRegex = new RegExp("(?=.*[A-Z])");

        let validation = {
            UpperCased: UpperRegex.test(this.props.password),
            LowerCased: this.props.password ? LowerRegex.test(this.props.password) : false,
            Special: SpecialRegex.test(this.props.password),
            Numbered: NumberRegex.test(this.props.password),
            Lengthed: this.props.password ? LengthRegex.test(this.props.password) : false
        }

        return validation

    }
    render() {
        let passwordChecker = this.passwordValidataion()
        let length = passwordChecker.Lengthed ? 'green' : 'red'
        let uppercase = passwordChecker.UpperCased ? 'green' : 'red'
        let lowercase = passwordChecker.LowerCased ? 'green' : 'red'
        let special = passwordChecker.Special ? 'green' : 'red'
        let number = passwordChecker.Numbered ? 'green' : 'red'
        return (
            <>
                <div className="text-muted">
                    *password requirement
                            </div>
                <div style={{ color: length }}> - Password atleast must have 4 caharacters or more uppercase</div>
                <div style={{ color: uppercase }}> - Password atleast must have one uppercase letter</div>
                <div style={{ color: lowercase }}> - Password atleast must have one lowercase letter</div>
                <div style={{ color: number }}> - Password atleast must have one number</div>
                <div style={{ color: special }}> - Password atleast must have one special character</div>
            </>
        )
    }
}
